export const ACTION_CELL_ACTION_TYPES = {
  REMOVE_ROW: 'REMOVE_ROW',
  EDIT_DETAILS: 'EDIT_DETAILS',
  DISPLAY_DETAILS: 'DISPLAY_DETAILS',
  DISPLAY_HISTORY: 'DISPLAY_HISTORY',
  DISPLAY_LISTING_STRATEGY: 'DISPLAY_LISTING_STRATEGY',
}
